<template>
 <div class="container">

<h1><b-icon icon="wallet2"></b-icon> Financial
<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>


<help id="12" />



</div>
</h1>

 

<div class="row">

 <!-- <div>
        <collapse :selected="true">
			<div slot="collapse-header">
hhhhddd
			</div>
			<div slot="collapse-body">
werwewewe
			</div>
		</collapse>
    </div> -->

   <div class="row">
 <div class="col-md-3 img-responsive">
        <img
          src="../../assets/financial-aid.jpg"
          width="462"
          alt="Circle image"
          class="militray-img"
        />
      </div>
      <div class="col-md-9 pt-4">
        <div class="panal mt-20" style="margin-left: -48px">
          <div class="panal-body row pl-5">
            <h1 class="w-100">Information About Financial</h1>
            <p>
          This screen with help you to manage all your university financial situation and track all your current and past transactions for debit and credit transactions and viewing your current account balance 
           
           
             
            </p>
          </div>
        </div>
      </div>

   </div>


 <div class="accordion col-md-12 mt-5" role="tablist">

     <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info" class="text-left" v-b-tooltip.hover title="Financial Data">Financial Data</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible  accordion="my-accordion" role="tabpanel">
        <b-card-body>
       
          <div>   <FinancialData/></div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info"  class="text-left" v-b-tooltip.hover title="Student Account">Student Account</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div> <StudentAccount/></div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-3 variant="info"  class="text-left" v-b-tooltip.hover title="Cash Receipt">Cash Receipt</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
         
          <div>   <CashReceipt/></div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-4 variant="info"  class="text-left" v-b-tooltip.hover title="Charges">Charges</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div> <Charges/></div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-5 variant="info"  class="text-left" v-b-tooltip.hover title="Scholarship">Scholarship</b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div>  <Scholarship/></div>
        </b-card-body>
      </b-collapse>
    </b-card>

      <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-6 variant="info"  class="text-left" v-b-tooltip.hover title="Student History">Student History</b-button>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>      <StudentHistorySearch/></b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>




<!-- 
  <div class="col-md-3 border-right">
    <Tap/>
  </div> -->
  <!-- <div class="col-md-9">







    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-Personal" role="tabpanel" aria-labelledby="v-pills-Personal-tab"><CashReceipt/></div>
      <div class="tab-pane fade" id="v-pills-Contact" role="tabpanel" aria-labelledby="v-pills-Contact-tab"><Charges/></div>
      <div class="tab-pane fade" id="v-pills-Education" role="tabpanel" aria-labelledby="v-pills-Education-tab"><Scholarship/></div>
      <div class="tab-pane fade" id="v-pills-Attachments" role="tabpanel" aria-labelledby="v-pills-Attachments-tab"><StudentHistorySearch/></div>

    </div>
  </div> -->





</div>




</div>

</template>

<script>
// import Tap from "../../components/Financial/Tap.vue";
// import { BCollapse } from 'bootstrap-vue';
// import Collapse from "vue-collapse";
import FinancialData from "../../components/Financial/FinancialData.vue";
import StudentAccount from "../../components/Financial/StudentAccount.vue";
import CashReceipt from "../../components/Financial/CashReceipt.vue";
import Charges from "../../components/Financial/Charges.vue";
import Scholarship from "../../components/Financial/Scholarship.vue";
import StudentHistorySearch from "../../components/Financial/StudentHistorySearch.vue";
// import modernizr.custom from "../assets/modernizr.custom.js";

//import ApplicantService from '../../services/Applicant/Applicant.service'
import Help from '../Help.vue';



export default {


  


   

  // @import url('../assets/modernizr.custom.js');
   components: {
     CashReceipt,Charges,Scholarship,StudentHistorySearch,FinancialData,StudentAccount,
      Help
  
  },
  

//   mounted() {
//   const s = document.createElement('script');
//   s.type = 'text/javascript';
//   s. SRC = './../../assets/modernizr.custom.js';
//   document.body.appendChild(s);
//  },

  //  mounted() {
  //     let recaptchaScript = document.createElement('script')
  //     recaptchaScript.setAttribute('src', './../../assets/modernizr.custom.js')
  //     document.head.appendChild(recaptchaScript)
  //   },
  data () {
    return {
    //    el: '#tabs',
    // activetab: 1,
      info: '',
      
      
      
    }
  },

 
  computed:{
    reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
  },
   mounted() {





    // this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
    //  // console.log('collapseId:', collapseId)
    //  // console.log('isJustShown:', isJustShown)
    // })
  }
}


</script>

<style scoped>
.help{
  color: #fff;
    background-color: #ff8600;
  
}
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}
.modal-footer {
    background: #f6f6f6 !important;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

/* Style the tabs */
.tabs {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px; 
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #285475;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
     color: #fff;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
   background-color: #fff;
    color: #285475;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

.btn-info {
    color: #fff;
    background-color: #eef6fb;
    border-color: rgb(178 188 198 / 25%);
    color: #1E5B8B !important;
    padding: 1em 2em !important;
    text-align: left;
    width: 100%;
    font-weight: 800;
}

.btn-info:hover {
    color: #fff !important;
    background-color: #285475;
    border-color: #204866;
}

.btn-info.focus, .btn-info:focus {
 color: #1E5B8B !important;
    background-color: #eef6fb;
    border-color: #204866;
}
.show {
     display: block; 
}
table {
    border-spacing: 1;
    border-collapse: collapse;
    background: white;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    position: relative;
}

.faq-table {
    margin-bottom: 3em;
}

.faq-table.yellow tr {
    border: 1px solid #F1BA1B;
    border-left: transparent;
    border-right: transparent;
}
@media screen and (max-width : 600px) {
  .militray-img{
    width:75vw !important
  }
  .panal{
    margin : 0px !important
  }
  .card-body{
    padding: 2px;
  }
  .row{
    margin : 0px !important
  }
}
/* @import url('./../../assets/tabs.css');
@import url('./../../assets/tabstyles.css'); */


</style>
